import { homeServiceOther } from "@/data/data";
import ServiceAreaCard from "./service-area-other-card";
import ServiceAreaOtherCard from "../pages/use-case/service-area-other-card";
import { ICPServiceOtherType1 } from "@/types/global";

interface Props {
    title: string;
    description?: string;
    onModalOpen?: (modalTitle?: string) => void;
    data?: ICPServiceOtherType1[];
}

const ServiceAreaOther = ({ title, description, onModalOpen, data }: Props) => {
    return (
        <>
            <section
                className="desilo-service6-section bg-color-2 section-padding-top-bottom overflow-hidden"
                id="service-section"
            >
                <div className="container custom-container">
                    <div className="row gx-4 gy-5">
                        <div className="col-12 col-xl-5 col-xxl-6">
                            <div className="desilo__header text-left text-lg-start">
                                <h2 className="title">
                                    {title}
                                </h2>
                                <p className="hero2-content-text">
                                    {description}
                                </p>
                            </div>
                        </div>
                        <div className="col-12 row-padding-top mt-0">
                            <div className="row g-4">
                                {/* service card start */}
                                {data ? (
                                    data.map((item, i) => (
                                        <ServiceAreaOtherCard
                                            key={i}
                                            data={item}
                                            onModalOpen={onModalOpen}
                                        />
                                    ))
                                ) : (
                                    homeServiceOther.map((item, i) => (
                                        <ServiceAreaCard
                                            key={i}
                                            data={item}
                                            onModalOpen={onModalOpen}
                                        />
                                    ))
                                )}
                                {/* service card end */}
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default ServiceAreaOther;
